import { render, staticRenderFns } from "./Kyiv.vue?vue&type=template&id=a3e3b300"
import script from "./Kyiv.vue?vue&type=script&lang=js"
export * from "./Kyiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports